import { render } from "./WidgetContent.vue?vue&type=template&id=288bbfd9"
import script from "./WidgetContent.vue?vue&type=script&lang=js"
export * from "./WidgetContent.vue?vue&type=script&lang=js"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__